import { Fax, Help } from "@mui/icons-material";
import { Navigate, Outlet, Route } from "react-router-dom";
import FeeSchedule from "../../components/app/provider/billing/FeeSchedule";
import ProviderCatalog from "../../components/app/provider/lib/ProviderCatalog";
import ProviderDataImport from "../../components/app/provider/lib/ProviderDataImport";
import EducationLayout from "../../components/app/provider/lib/education-material/EducationLayout";
import ProviderFormBuilderHost from "../../components/app/provider/lib/form-builder/ProviderFormBuilderHost";
import ProviderFormBuilderTable from "../../components/app/provider/lib/form-builder/ProviderFormBuilderTable";
import ProviderTemplateHost from "../../components/app/provider/lib/template/ProviderTemplateHost";
import ProviderTemplateTable from "../../components/app/provider/lib/template/ProviderTemplateTable";
import ProviderRolesAndResponsibility from "../../components/app/settings/ProviderRolesAndResponsibility";
import ProviderPortalLayout from "../../layout/app/provider/ProviderPortalLayout";
import ProviderGroupPatients from "../../pages/app/ProviderGroupPatients";
import CatalogCPTCodeCatalog from "../../pages/app/admin/library/catalog/CatalogCPTCodeCatalog";
import CatalogDiagnosisCodeCatalog from "../../pages/app/admin/library/catalog/CatalogDiagnosisCodeCatalog";
import CatalogDrugCatalog from "../../pages/app/admin/library/catalog/CatalogDrugCatalog";
import CatalogHCPCSCodeCatalog from "../../pages/app/admin/library/catalog/CatalogHCPCSCodeCatalog";
import CatalogLOINCCodeCatalog from "../../pages/app/admin/library/catalog/CatalogLOINCCodeCatalog";
import ProviderGroupDepartments from "../../pages/app/admin/provider-groups/ProviderGroupDepartments";
import ProviderGroupLocations from "../../pages/app/admin/provider-groups/ProviderGroupLocations";
import ProviderGroupProfile from "../../pages/app/admin/provider-groups/ProviderGroupProfile";
import BillingLayout from "../../pages/app/provider/billings/BillingsLayout";
import CreatePRInvoiceLayout from "../../pages/app/provider/billings/CreatePRInvoiceLayout";
import SuperBillingLayout from "../../pages/app/provider/billings/SuperBillingLayout";
import UpdateSuperBillingLayout from "../../pages/app/provider/billings/UpdateSuperBillingLayout";
import ViewSuperBillingLayout from "../../pages/app/provider/billings/ViewSuperBillingLayout";
import AccountReceivableLayout from "../../pages/app/provider/billings/account-receivable/AccountReceivableLayout";
import InsuranceListingTable from "../../pages/app/provider/billings/account-receivable/insurance/InsuranceListingTable";
import PatientListingTable from "../../pages/app/provider/billings/account-receivable/patient/PatientListingTable";
import AccountReceivableSummery from "../../pages/app/provider/billings/account-receivable/summery/AccountReceivableSummery";
import UpdateEraEobDetails from "../../pages/app/provider/billings/claims/UpdateEraEobDetails";
import UpdateClaimsLayout from "../../pages/app/provider/billings/claims/updateClaims/UpdateClaimsLayout";
import EraDetailPage from "../../pages/app/provider/billings/era-eob/EraDetailPage";
import PatientPayments from "../../pages/app/provider/billings/payments/PatientPayments";
import RefillRequests from "../../pages/app/provider/collaboration/RefillRequests";
import Results from "../../pages/app/provider/collaboration/Results";
import OpenEncounters from "../../pages/app/provider/collaboration/open-encounter/OpenEncounters";
import CollaborationLayout from "../../pages/app/provider/collabration/CollaborationLayout";
import PatientInquiries from "../../pages/app/provider/collabration/patient-inquiries/PatientInquiries";
import Referrals from "../../pages/app/provider/collabration/referrals/Referrals";
import Tasks from "../../pages/app/provider/collabration/tasks/Tasks";
import CommunicationLayout from "../../pages/app/provider/communications/CommunicationLayout";
import ContactDictionary from "../../pages/app/provider/communications/contact-dictionary/ContactDictionary";
import EmailTable from "../../pages/app/provider/communications/email/EmailTable";
import SmsText from "../../pages/app/provider/communications/messages/SmsText";
import Dashboard from "../../pages/app/provider/dashboard/Dashboard";
import EditPatient from "../../pages/app/provider/patient/EditPatient";
import PatientLayout from "../../pages/app/provider/patient/PatientLayout";
import PatientFlagList from "../../pages/app/provider/patient/flags/PatientFlagList";
import ConsentForms from "../../pages/app/provider/patient/patient-list/ConsentForms";
import PatientList from "../../pages/app/provider/patient/patient-list/PatientList";
import PatientChartNewLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/PatientChartNewLayout";
import PatientChat from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientChat";
import PatientCommunicationLayoutNewChart from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientCommunicationLayoutNewChart";
import PatientEmailTable from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientEmailTable";
// import PatientSms from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientSms";
import AuditLog from "../../pages/app/admin/settings/AuditLog";
import PatientPortalAccess from "../../pages/app/provider/patient/patient-list/patient-chart-new/access/PatientAccess";
import ClinicalLayoutNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/ClinicalLayoutNew";
import AllergiesList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/AllergiesList";
import CarePlanList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/CarePlanList";
import DiagnosisList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/DiagnosisList";
import MedicationsList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/MedicationsList";
import VaccinesList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/VaccinesList";
import VitalsList from "../../pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/VitalsList";
import DemoGraphicsLayoutNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/DemoGraphicsLayout";
import DemographicsNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/DemographicsNew";
import PatientEligibility from "../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/eligibility/PatientEligibility";
import PatientEducationMaterial from "../../pages/app/provider/patient/patient-list/patient-chart-new/education-material/PatientDocLayout";
import FinancialLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/FinancialLayout";
import PatientBalance from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientBalance";
import PatientBills from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientBills";
import PatientCardDetails from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientCardDetails";
import PatientClaims from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientClaims";
import PatientEraEob from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientEraEob";
import PatientInsurancePayment from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientInsurancePayment";
import PatientLedger from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientLedger";
import PatientPaymentsNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientPaymentsNew";
import PatientReadyForBilling from "../../pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientReadyForBilling";
import PatientChartForms from "../../pages/app/provider/patient/patient-list/patient-chart-new/forms/PatientChartForms";
import HistoryLayoutNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/history/HistoryLayoutNew";
import PastMedicalHistoryNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/history/PastMedicalHistory";
import PastSurgicalHistoryNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/history/PastSurgicalHistory";
import PatientFamilyHistoryNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/history/PatientFamilyHistory";
import SocialHistoryNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/history/SocialHistoryNew";
import PatientOrderNewLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/PatientOrderLayout";
import PatientOrderNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNew";
import OrderPrescriptionNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/prescription/OrderPrescriptionNew";
import OderResultNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/result/OderResultNew";
import PatientChronologicalAndRequiringActionLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-chronological-records-and-requiring-actions/patientChronologicalAndRequiringActionLayout";
import PatientTask from "../../pages/app/provider/patient/patient-list/patient-chart-new/tasks/PatientTask";
import PatientVisitHistory from "../../pages/app/provider/patient/patient-list/patient-chart-new/visit-history/PatientVisitHistory";
import BillingReports from "../../pages/app/provider/reports/BillingReports";
import ReportsLayout from "../../pages/app/provider/reports/ReportsLayout";
import AppointmentScheduling from "../../pages/app/provider/scheduling/appointment/AppointmentScheduling";
import Availability from "../../pages/app/provider/scheduling/availability/Availability";
import SettingsLayout from "../../pages/app/provider/settings/SettingsLayout";
import AccountSettings from "../../pages/app/provider/settings/account-setting/AccountSettings";
// import ClaimIntegrationList from "../../pages/app/provider/settings/claim-integration/ClaimIntegrationList";
import ProviderGroupAppoinmentType from "../../pages/app/admin/provider-groups/ProviderGroupAppoinmentType";
import PatientAssementForms from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/PatientAssementForms";
import PatientAssementLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/PatientAssementLayout";
import PatientSendAssessments from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientAssementForms/SchedulePatientAssementForms";
import PatientChartAssessment from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/PatientChartAssessment";
import ScheduledAssessment from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/ScheduledAssessment";
import ScreeningAssessment, {
  ScreeningTable,
} from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/ScreeningAssessment";
import AssessmentSummaryLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/assessment/summary/AssessmentSummaryLayout";
import PatientInsuranceNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/insurance/PatientInsuranceNew";
import PatientEncounter from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientEncounter";
// import PatientVisitNoteLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientVistNoteLayout";
import UserSettingsLayout from "../../layout/app/admin/UserSettingsLayout";
import ReadyForBillingTab from "../../pages/app/provider/billings/ReadyForBillingTab";
import SuperBill from "../../pages/app/provider/billings/SuperBill";
import EraEobTab from "../../pages/app/provider/billings/era-eob/EraEobTab";
import EraWorklist from "../../pages/app/provider/billings/era-eob/EraWorklist";
import EobWorklist from "../../pages/app/provider/billings/era-eob/EobWorklist";
import AccountReceivableInsuranceTable from "../../pages/app/provider/billings/account-receivable/insurance/AccountReceivableInsuranceTable";
import AccountReceivablePatientTable from "../../pages/app/provider/billings/account-receivable/patient/AccountReceivablePatientTable";
import Assessments from "../../pages/app/provider/collabration/assessments/Assessments";
import Chat from "../../pages/app/provider/communications/chat/Chat";
import FaxLayout from "../../pages/app/provider/communications/fax/FaxLayout";
import IncomingFax from "../../pages/app/provider/communications/fax/IncomingFax";
import OutgoingFax from "../../pages/app/provider/communications/fax/OutgoingFax";
import PatientCallTable from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientCallTable";
import PatientVisitNoteLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientVistNoteLayoutNew";
import PatientReferral from "../../pages/app/provider/patient/patient-list/patient-chart-new/referral/PatientReferral";
import Authorization from "../../pages/app/provider/patient/patient-list/patient-chart/demographics/authorization/Authorization";
import SchedulingLayout from "../../pages/app/provider/scheduling/SchedulingLayout";
import ProviderConfig from "../../pages/app/provider/settings/ProviderConfig";
import FlagList from "../../pages/app/provider/settings/flag-setting/FlagList";
import FlagSettingtLayout from "../../pages/app/provider/settings/flag-setting/FlagSettingtLayout";
import PracticeSettingLayout from "../../pages/app/provider/settings/practice-setting/PracticeSettingLayout";
import PrintConfiguration from "../../pages/app/provider/settings/practice-setting/PrintConfiguration";
import ProviderUserDetails from "../../pages/app/provider/settings/practice-setting/ProviderUserDetails";
import UserDetails from "../../pages/app/provider/settings/practice-setting/UserDetails";
import PatientIdConfiguration from "../../pages/app/provider/settings/practice-setting/patient-id-config/PatientIdConfiguration";
import VisitNoteTemplateLayout from "../../pages/app/provider/settings/practice-setting/visit-note-template/VisitNoteTemplateLayout";
import { ProtectedRoute } from "../Router";
import ClaimsList from "../../pages/app/provider/billings/claims/ClaimsList";
import Payers from "@/pages/app/provider/settings/practice-setting/payers/Payers";
import ProviderGroupReferringAgency from "@/pages/app/admin/provider-groups/ProviderGroupReferringAgency";

export const ProviderRoute = () => {
  return (
    <Route
      path="provider"
      element={
        <ProtectedRoute accessingViewAs="provider">
          <ProviderPortalLayout />
        </ProtectedRoute>
      }
    >
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="scheduling" element={<SchedulingLayout />}>
        <Route path="appointment" element={<AppointmentScheduling />} />
        <Route path="availability" element={<Availability />} />
      </Route>

      <Route path="patients" element={<PatientLayout />}>
        <Route index element={<PatientList />} />
        <Route path="new-patient" element={<Outlet />}>
          <Route path=":patientId" element={<PatientChartNewLayout />}>
            <Route
              path="index"
              element={<PatientChronologicalAndRequiringActionLayout />}
            />
            <Route path="financial" element={"financial"} />
            <Route path="forms" element={<PatientChartForms />} />
            <Route path="assessment" element={<PatientChartAssessment />}>
              {/* <Route index element={<CompletedAssessment />} /> */}
              <Route index element={<AssessmentSummaryLayout />} />
              <Route path="screening" element={<ScreeningAssessment />}>
                <Route index element={<ScreeningTable />} />
                {/* <Route path="start-new" element={<ScreeningStartNewLayout />} /> */}
              </Route>
              <Route path="scheduled" element={<ScheduledAssessment />} />

              <Route path="assessments" element={<PatientAssementLayout />}>
                <Route index element={<PatientAssementForms />} />
                <Route path="schedule" element={<PatientSendAssessments />} />
              </Route>
            </Route>
            <Route
              path="communication"
              element={<PatientCommunicationLayoutNewChart />}
            >
              {/* Todo: need to add sms table back */}
              {/* <Route index element={<PatientSMSTable />} /> */}
              <Route index element={<PatientChat />} />
              <Route path="email" element={<PatientEmailTable />} />
              <Route path="call" element={<PatientCallTable />} />
            </Route>
            <Route path="tasks" element={<PatientTask />} />
            <Route path="referral" element={<PatientReferral />} />
            {/* note : this route has updated to patient education material  due to merger of documents and education material */}
            <Route path="documents" element={<PatientEducationMaterial />} />
            <Route path="history" element={<HistoryLayoutNew />}>
              <Route index element={<PastMedicalHistoryNew />} />
              <Route path={"surgical"} element={<PastSurgicalHistoryNew />} />
              <Route path={"family"} element={<PatientFamilyHistoryNew />} />
              <Route path={"social"} element={<SocialHistoryNew />} />
            </Route>
            <Route path="prescription" element={<OrderPrescriptionNew />} />
            <Route path="order" element={<PatientOrderNewLayout />}>
              <Route index element={<PatientOrderNew />} />
              <Route path="result" element={<OderResultNew />} />
            </Route>
            <Route path="visit-history" element={<PatientVisitHistory />} />
            <Route path="visit-note" element={<PatientVisitNoteLayout />}>
              <Route path="form" element={<PatientEncounter />}>
                <Route
                  index
                  element={
                    <PatientChronologicalAndRequiringActionLayout
                      shouldHideCreateVisitNote
                    />
                  }
                />
              </Route>
            </Route>
            <Route path="demographics" element={<DemoGraphicsLayoutNew />}>
              <Route index element={<DemographicsNew />} />
              <Route path="insurance" element={<PatientInsuranceNew />} />
              <Route path="eligibility" element={<PatientEligibility />} />
              <Route path="authorization" element={<Authorization />} />
              <Route path="portal-access" element={<PatientPortalAccess />} />
            </Route>
            <Route path="financial" element={<FinancialLayout />}>
              <Route index element={<PatientBills />} />
              <Route
                path={"ready-for-billing"}
                element={<PatientReadyForBilling />}
              />
              <Route path={"claims"} element={<PatientClaims />} />
              <Route path={"era-eob"} element={<PatientEraEob />} />
              <Route path={"payments"} element={<PatientPaymentsNew />} />
              <Route
                path={"insurance-payment"}
                element={<PatientInsurancePayment />}
              />
              <Route path={"patientbalance"} element={<PatientBalance />} />
              <Route path={"carddetails"} element={<PatientCardDetails />} />
              <Route path={"ledger"} element={<PatientLedger />} />
            </Route>
            <Route path="clinical-details" element={<ClinicalLayoutNew />}>
              <Route index element={<AllergiesList />} />
              <Route path={"diagnosis"} element={<DiagnosisList />} />
              <Route path={"medications"} element={<MedicationsList />} />
              <Route path={"vaccines"} element={<VaccinesList />} />
              <Route path={"vitals"} element={<VitalsList />} />
              <Route path={"care_plan"} element={<CarePlanList />} />
            </Route>
          </Route>
        </Route>

        {/* <Route path="add-patient" element={<AddPatient />} /> */}
        <Route path="edit-patient/:patientId" element={<EditPatient />} />
        <Route path="consent-forms" element={<ConsentForms />} />
        <Route path="flags" element={<PatientFlagList />} />
      </Route>

      <Route path="communications" element={<CommunicationLayout />}>
        <Route index element={<SmsText />} />
        <Route path="chat" element={<Chat />} />
        <Route path="email" element={<EmailTable />} />
        <Route path="fax" element={<Fax />} />
        <Route path="dictionary" element={<ContactDictionary />} />
        <Route path="fax" element={<FaxLayout />}>
          <Route index element={<IncomingFax />} />
          <Route path="outgoing-fax" element={<OutgoingFax />} />
          {/* <Route path="fax-folder" element={<FaxFolder />} /> */}
        </Route>
      </Route>

      <Route path="collaboration" element={<CollaborationLayout />}>
        <Route path="tasks" element={<Tasks />} />
        <Route path="referrals" element={<Referrals />} />
        <Route path="patient-inquiries" element={<PatientInquiries />} />
        <Route path="refill-request" element={<RefillRequests />} />
        <Route path="results" element={<Results />} />
        <Route path="open-encounters" element={<OpenEncounters />} />
        <Route path="assessments" element={<Assessments />} />
      </Route>

      <Route path="billing" element={<Outlet />}>
        <Route path="claims/edit-claim" element={<UpdateClaimsLayout />} />
        <Route path="update-era-eob" element={<UpdateEraEobDetails />} />
        <Route element={<BillingLayout />}>
          <Route index element={<ReadyForBillingTab />} />
          <Route path="claims" element={<ClaimsList />}></Route>
          <Route path="invoice" element={<SuperBill />} />
          <Route path="era_eob" element={<EraEobTab />}>
            <Route index element={<Navigate to="era" replace />} />
            <Route path="era" element={<EraWorklist />} />
            <Route path="eob" element={<EobWorklist />} />
          </Route>
        </Route>

        {/* invoice from encounter  */}
        <Route
          path="invoice/:patientId/:encounterId"
          element={<SuperBillingLayout />}
        />

        {/* new invoice  using*/}
        <Route path="add-invoice" element={<SuperBillingLayout />} />

        {/* modify invoice  using*/}
        <Route
          path="update-invoice/:patientId/:superBillId"
          element={<UpdateSuperBillingLayout />}
        />

        {/* view invoice  using*/}
        <Route
          path="view-invoice/:patientId/:superBillId"
          element={<ViewSuperBillingLayout />}
        />

        {/* create PR invoice from claim */}
        <Route
          path="create-pr-invoice/:patientId/:claimId"
          element={<CreatePRInvoiceLayout />}
        />

        <Route path="era-eob/:eraUuid" element={<EraDetailPage />} />

        {/* <Route path="payments" element={<Payments />} /> */}
        <Route path="payments" element={<PatientPayments />} />

        <Route path="account-receivable" element={<AccountReceivableLayout />}>
          <Route path="summary" element={<AccountReceivableSummery />} />
          <Route path="patient" element={<AccountReceivablePatientTable />} />
          <Route
            path="insurance"
            element={<AccountReceivableInsuranceTable />}
          />
          <Route path="patient-listing/:id" element={<PatientListingTable />} />
          <Route path="payer-listing/:id" element={<InsuranceListingTable />} />
        </Route>
        <Route path="fee-schedule" element={<FeeSchedule />} />
      </Route>
      <Route path="reports" element={<ReportsLayout />}>
        <Route path="billing-report" element={<BillingReports />} />
      </Route>
      <Route path="library">
        <Route index element={<ProviderDataImport />} />
        <Route path="catalog" element={<ProviderCatalog />}>
          <Route index element={<CatalogLOINCCodeCatalog />} />
          <Route path="drug-catalog" element={<CatalogDrugCatalog />} />
          <Route
            path="diagnosis-catalog"
            element={<CatalogDiagnosisCodeCatalog />}
          />
          <Route path="cpt-code-catalog" element={<CatalogCPTCodeCatalog />} />
          <Route
            path="hcpcs-code-catalog"
            element={<CatalogHCPCSCodeCatalog />}
          />
        </Route>
        <Route path="form-builder" element={<ProviderFormBuilderTable />} />
        <Route path="form-builder-host" element={<ProviderFormBuilderHost />} />
        <Route path="templates" element={<ProviderTemplateTable />} />
        <Route path="templates-host" element={<ProviderTemplateHost />} />
        <Route path="education-material" element={<EducationLayout />} />
        <Route path="visit-templates" element={<VisitNoteTemplateLayout />} />
      </Route>
      <Route path="settings" element={<SettingsLayout />}>
        <Route path="account-settings" element={<AccountSettings />} />
        {/* <Route path="flag-settings" element={<FlagList />} /> */}
        <Route path="flag-settings" element={<FlagSettingtLayout />}>
          <Route index element={<FlagList />} />
          <Route path="patient-flag-settings" element={<PatientFlagList />} />
        </Route>

        <Route path="practice-settings" element={<PracticeSettingLayout />}>
          <Route index element={<ProviderGroupProfile />} />
          <Route path="locations" element={<ProviderGroupLocations />} />
          <Route path="departments" element={<ProviderGroupDepartments />} />
          <Route
            path="referring-agency"
            element={<ProviderGroupReferringAgency />}
          />
          <Route path="payers" element={<Payers />} />
          <Route path="patients" element={<ProviderGroupPatients />} />
          <Route path="print-configuration" element={<PrintConfiguration />} />
          <Route path="configuration" element={<ProviderConfig />} />
          <Route
            path="appointment-type-configuration"
            element={<ProviderGroupAppoinmentType />}
          />
          {/* <Route path="configuration" element={<ClaimIntegrationList />} /> */}
          <Route path="audit-log" element={<AuditLog />} />
          <Route
            path="patient-id-configuration"
            element={<PatientIdConfiguration />}
          />
        </Route>
        <Route path="user-settings" element={<UserSettingsLayout />}>
          <Route index element={<UserDetails />} />
          <Route path="provider-users" element={<ProviderUserDetails />} />
          <Route
            path="role-responsibility"
            element={<ProviderRolesAndResponsibility />}
          />
        </Route>
      </Route>
      <Route path="help" element={<Help />} />
    </Route>
  );
};

// unread message
